import React, { useState } from 'react';
import MoverService from '../../../services/MoverService';
import DatePicker from 'react-date-picker';
import { connect } from 'react-redux';
import { formatStringDate } from '../../../helpers/dateFormatter'
import { parseISO } from 'date-fns';

function MoverComponent(props) {
    const [edit, setEdit] = useState(false);
    const [mover, setMover] = useState(props.mover);
    const [number, setNumber] = useState(props.mover.apartment.number);

    const editClick = () => {
        setEdit(!edit);
    };

    const save = () => {
        var newApartment = props._apartments.filter(x => x.number === parseInt(number));

        MoverService.update({ ...mover, apartment_id: newApartment[0].id, apartment: null });

        editClick();
    };

    const deleteMover = () => {
        if (window.confirm("er du sikker på at du vil slette " + props.mover.seller_name + " fra fraflyttere?")) {
            MoverService.delete(props.mover);
        }
    };

    return (
        <tbody>
            {!edit ?
                <tr>
                    <td style={{ textAlign: "center" }}>{formatStringDate(props.mover.takeover_date)}</td>
                    <td style={{ textAlign: "center" }}>{props.mover.apartment.number}</td>
                    <td>{props.mover.seller_name}</td>
                    <td>{props.mover.seller_address} {props.mover.seller_postcode} {props.mover.seller_suburb}</td>
                    <td>{props.mover.seller_email}</td>
                    <td>{props.mover.buyer_name}</td>
                    <td style={{ whiteSpace: 'nowrap' }}>
                        <button className="btn  pull-right" onClick={editClick}>
                            <span className='bi bi-document-text'></span>
                        </button>&nbsp;&nbsp;
                        <button className="btn pull-right" onClick={deleteMover}>
                            <span className='bi bi-circle-fill'></span>
                        </button>
                    </td>
                </tr>
                :
                <tr>
                    <td colSpan="9">
                        <div className="panel panel-default">
                            <div className="panel-body textAlignLeft">
                                <div className="col-md-12">
                                    <form className="apartmentForm" id="apartmentForm" onSubmit={save}>
                                        <div className="row">
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Overtagelsesdato</label>
                                                </div>
                                                <DatePicker
                                                    dateFormat="dd/MM/yyyy"
                                                    value={mover.takeover_date ? new Date(parseISO(mover.takeover_date)) : null}
                                                    onChange={date => { setMover({ ...mover, takeover_date: date.toISOString() }) }}
                                                    className="form-control"
                                                />
                                            </div>
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Andels nr.</label>
                                                </div>
                                                <input className="form-control" name="type" value={number} onChange={(event) => setNumber(event.target.value)} type="text" />
                                            </div>
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Sælgers navn</label>
                                                </div>
                                                <input className="form-control" name="type" value={mover.seller_name} onChange={(event) => setMover({ ...mover, seller_name: event.target.value })} type="text" />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Sælgers addresse</label>
                                                </div>
                                                <input className="form-control" name="type" value={mover.seller_address} onChange={(event) => setMover({ ...mover, seller_address: event.target.value })} type="text" />
                                            </div>
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Sælgers by</label>
                                                </div>
                                                <input className="form-control" name="type" value={mover.seller_suburb} onChange={(event) => setMover({ ...mover, seller_suburb: event.target.value })} type="text" />
                                            </div>
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Sælgers postnummer</label>
                                                </div>
                                                <input className="form-control" name="type" value={mover.seller_postcode} onChange={(event) => setMover({ ...mover, seller_postcode: event.target.value })} type="text" />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Sælgers e-mail</label>
                                                </div>
                                                <input className="form-control" name="type" value={mover.seller_email} onChange={(event) => setMover({ ...mover, seller_email: event.target.value })} type="text" />
                                            </div>
                                            <div className="col-md-4 panelRowPadding ">
                                                <div>
                                                    <label>Købers navn</label>
                                                </div>
                                                <input className="form-control" name="type" value={mover.buyer_name} onChange={(event) => setMover({ ...mover, buyer_name: event.target.value })} type="text" />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 panelRowPadding">
                                                <button className="btn btn-primary" onClick={save} >Gem</button>
                                                <button className="btn btn-primary ml-2" onClick={editClick}>Afbryd</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            }
        </tbody>
    );
}

function mapStateToProps(state) {
    const { _apartments } = state.apartments;
    return { _apartments };
}

export default connect(mapStateToProps)(MoverComponent);